import React, { useState } from 'react';
import { useAtomValue } from 'jotai';
import { useIntl } from 'react-intl';
import { useForm, FormProvider } from 'react-hook-form';
import { TextField } from '@mui/material';
import Information from '../../../PracticesPage/Components/Information';
import { FullSizeColumn } from '../../../../Components/FlexBox';
import ActionButtons from './ActionButtons';
import { ACTIVITY_TYPES_FORMS } from '../../../../Utils/constants/activityTypes';
import { activityTypesAtom } from '../../../../Atoms';
import Summary from './Summary';

const ResultForm = function ResultForm({
  campaignId,
  selectedOutcomeId,
  outcomes,
  isOperator,
  handleResetOutcome,
  onSubmit,
  phoneNumber,
  sectionId,
  wavePeriod,
}) {
  const intl = useIntl();
  const methods = useForm();

  const activityTypes = useAtomValue(activityTypesAtom);

  const [notes, setNotes] = useState(null);
  const [confirmed, setConfirmed] = useState(false);

  const handleConfirm = () => {
    setConfirmed(!confirmed);
  };

  const selectedOutcome = outcomes.find(({ id }) => id === selectedOutcomeId);

  const handleSubmit = (data = {}) => {
    let nextActivityData = data ? { ...data } : null;

    // Convert any "ALL" values to null
    if (nextActivityData) {
      nextActivityData = Object.fromEntries(
        Object.entries(nextActivityData).map(([key, value]) => [
          key,
          value === 'ALL' ? null : value,
        ])
      );
    }

    const payload = {
      outcome: selectedOutcomeId,
      notes,
      campaignId,
      nextActivityData,
    };
    onSubmit(payload);
  };

  const nextActivityTypeName = activityTypes.find(
    ({ id }) => id === selectedOutcome?.extensionData?.nextActType
  )?.name;

  const FormComponent =
    nextActivityTypeName && ACTIVITY_TYPES_FORMS[nextActivityTypeName];
  return (
    <FormProvider {...methods}>
      <FullSizeColumn gap="16px" sx={{ overflow: 'hidden' }}>
        <form
          style={{ display: 'contents' }}
          onSubmit={methods?.handleSubmit(handleSubmit, () => {})}
        >
          <FullSizeColumn
            sx={{ overflow: 'auto', flexGrow: 1, padding: '16px' }}
          >
            <Information
              styles={{
                root: { flex: 'unset', marginBottom: '16px' },
                valueStyle: { fontSize: '30px', fontWeight: 500 },
                captionStyle: {
                  color: 'primary.main',
                  textTransform: 'uppercase',
                },
              }}
              caption={confirmed && intl.messages.SUMMARY}
              value={
                intl.messages[selectedOutcome?.name?.toUpperCase()] ||
                selectedOutcome?.name
              }
            />
            {!FormComponent && confirmed && <Summary notes={notes} />}
            {FormComponent && (
              <FormComponent
                isOperator={isOperator}
                confirmed={confirmed}
                phoneNumber={phoneNumber}
                sectionId={sectionId}
                wavePeriod={wavePeriod}
              />
            )}
            {!FormComponent && !confirmed && (
              <TextField
                id="notes"
                variant="outlined"
                fullWidth
                multiline
                rows={10}
                label={intl.messages.NOTES}
                value={notes}
                onInput={(e) => {
                  setNotes(e.target.value);
                }}
                placeholder={intl.messages.INSERT_NOTES}
              />
            )}
          </FullSizeColumn>
          <ActionButtons
            returnToSelection={handleResetOutcome}
            handleConfirm={handleConfirm}
            confirmed={confirmed}
          />
        </form>
      </FullSizeColumn>
    </FormProvider>
  );
};

export default ResultForm;
